import { EPSILON } from "../constants";

/**
 * Validates if split amounts add up to the total amount
 */
export const validateSplitAmounts = (
  splitAmounts: { [userId: string]: number | string },
  totalAmount: number,
  userCount: number
): boolean => {
  // If single user or no splits, always valid
  if (userCount <= 1 || Object.keys(splitAmounts).length === 0) {
    return true;
  }

  const splitTotal = Object.values(splitAmounts).reduce((sum, val) => {
    const numVal = typeof val === 'string' ? parseFloat(val) || 0 : val;
    return sum + numVal;
  }, 0);

  return Math.abs(splitTotal - totalAmount) < EPSILON;
};

/**
 * Normalizes split amounts to numbers
 */
export const normalizeSplitAmounts = (
  splitAmounts: { [userId: string]: number | string }
): { [userId: string]: number } => {
  const normalized: { [userId: string]: number } = {};
  
  Object.entries(splitAmounts).forEach(([userId, val]) => {
    const numVal = typeof val === 'string' ? parseFloat(val) || 0 : val;
    normalized[userId] = numVal;
  });
  
  return normalized;
};

/**
 * Checks if a value is a valid positive number
 */
export const isValidAmount = (value: string | number): boolean => {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  return !isNaN(num) && num > 0;
};
